import { endOfDay, startOfDay } from 'date-fns';

/**
 * The date range the standalone appointment list sends to the API (AMP-141): the viewer's local
 * days, as exact instants from the start of the first day to the end of the last. The list shows
 * times in local time, so this is the day the viewer sees. A bare yyyy-MM-dd was read by the API
 * as UTC midnight, which made "Today" a zero-length range.
 */
export function appointmentDateParams(from?: Date, to?: Date): { dateFrom?: string; dateTo?: string } {
  return {
    dateFrom: from ? startOfDay(from).toISOString() : undefined,
    dateTo: to ? endOfDay(to).toISOString() : undefined,
  };
}
